<ui-dialog
    size="small"
    [isCloseable]="false"
    header="{{ 'payroll.workers-compensation.rateDetailsCannotBeChangedLater' | translate }}"
    [scrollable]="true"
    (primaryButtonPressed)="save(form)"
    primaryButtonLabel="{{ 'payroll.workers-compensation.createNewRate' | translate }}"
    [open]="showConfirmationModal"
    [secondaryButtonLabel]="'cancel' | translate"
    [secondaryButtonType]="'ghost'"
    (secondaryButtonPressed)="showConfirmationModal = false"
    (closing)="showConfirmationModal = false"
>
    <p>{{ 'payroll.workers-compensation.saveWarning' | translate }}</p>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true" [backRoute]="getBackRoute()"></app-header>
    <div class="app-grid">
        <ui-card class="columns-8">
            <app-workers-compensation-rate-form
                #form
                [workersCompensation]="workersCompensation"
            ></app-workers-compensation-rate-form>
            <div style="display: flex; justify-content: flex-end">
                <ui-button (click)="confirm()" type="primary"
                    >{{ 'payroll.workers-compensation.createNewRate' | translate }}
                </ui-button>
            </div>
        </ui-card>

        <ui-card class="columns-3"
            ><div [innerHTML]="'payroll.workers-compensation.howToEnterTheRate' | translate"></div
        ></ui-card>
    </div>
</div>
